import {FC, SVGProps} from 'react';

export const IndividualSuccessIcon: FC<SVGProps<SVGSVGElement>> = (props) => (
	<svg width="193" height="200" viewBox="0 0 193 200" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden {...props}>
		<path
			d="M179.662 129.206H90.8355C84.4111 129.206 79.2031 134.414 79.2031 140.838C79.2031 147.263 84.4111 152.471 90.8355 152.471H179.662C186.087 152.471 191.295 147.263 191.295 140.838C191.295 134.414 186.087 129.206 179.662 129.206Z"
			stroke="black"
			strokeWidth="2"
			strokeMiterlimit="10"
		/>
		<path
			d="M179.662 152.471H90.8355C84.4111 152.471 79.2031 157.679 79.2031 164.103C79.2031 170.527 84.4111 175.735 90.8355 175.735H179.662C186.087 175.735 191.295 170.527 191.295 164.103C191.295 157.679 186.087 152.471 179.662 152.471Z"
			stroke="black"
			strokeWidth="2"
			strokeMiterlimit="10"
		/>
		<path
			d="M179.662 175.735H90.8355C84.4111 175.735 79.2031 180.943 79.2031 187.368C79.2031 193.792 84.4111 199 90.8355 199H179.662C186.087 199 191.295 193.792 191.295 187.368C191.295 180.943 186.087 175.735 179.662 175.735Z"
			stroke="black"
			strokeWidth="2"
			strokeMiterlimit="10"
		/>
		<path d="M116.999 199H20.2031" stroke="black" strokeWidth="2" strokeMiterlimit="10" />
		<path
			d="M1 82.6887H18.8198C26.0591 82.6887 32.9519 79.595 37.7657 74.1871C40.6738 70.9078 43.6686 66.9973 46.5643 62.4062C52.9745 52.2712 61.0181 35.5033 62.961 13.2161C63.6045 5.8531 70.0889 0.40821 77.4519 1.0517C84.815 1.6952 90.2599 8.17958 89.6164 15.5426C87.2899 42.062 77.5138 65.401 65.1513 82.6887H168.024C180.869 82.6887 191.288 93.1083 191.288 105.953C191.288 118.799 180.869 129.218 168.024 129.218H90.8292C84.4066 129.218 79.1968 124.008 79.1968 117.586C79.1968 111.163 84.4066 105.953 90.8292 105.953H168.024"
			stroke="black"
			strokeWidth="2"
			strokeMiterlimit="10"
		/>
		<path
			d="M20.2058 82.6887H1V199H20.2058V82.6887Z"
			fill="black"
			stroke="black"
			strokeWidth="2"
			strokeMiterlimit="10"
		/>
	</svg>
);
